import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, forkJoin, Observable, of, Subject } from 'rxjs';
import { IGetCodes } from 'src/app/interfaces/codes';
import {
  IQuestionApplicableCourseResponse,
  IQuestionCourseCategorySelectedResponse,
  IQuestionsWithAnswersModifiedResponse,
  ISelectedCourses,
} from 'src/app/interfaces/questionManagement';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import {
  QuestionApplicableCourseCategoryList,
  QuestionApplicableCourseList,
  QuestionManagementService,
} from 'src/app/Services/question-management.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { ToastrService } from 'ngx-toastr';
import { sameCourseValidator } from 'src/app/Validators/Validators';
import { QuestionMultipleAssignComponent } from '../question-multiple-assign/question-multiple-assign.component';
import { catchError, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
@Component({
  selector: 'app-question-assign-modal',
  templateUrl: './question-assign-modal.component.html',
  styleUrls: ['./question-assign-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionAssignModalComponent implements OnInit {
  @Input() SubjectId: number | null;
  @Input() QuestionId: string | null;
  @Input() ScreenName: string;
  @Input() isEdit: boolean = false;
  @Input() filter: string = '';
  @Input() currentRoute: string;
  @Input() param:string | null = null;
  @Output() openQuestionEdit = new EventEmitter<any>();
  @Output() clearedRoute = new EventEmitter<any>();


  assignForm: FormGroup;
  courseCategoryList: IGetCodes[];
  Questions: IQuestionsWithAnswersModifiedResponse[] = [];
  path: string;
  applicableCoursesCategory: IQuestionCourseCategorySelectedResponse[];
  applicableCourse: IQuestionApplicableCourseResponse[];
  QuestionDifficulty: IGetCodes[] = [];
  savedCourseSelection: ISelectedCourses | null = null;
  selectedQuestions: boolean[] = [];
  courseName: any;
  examYearName: any;
  examAgencyName: any;
  successfullySavedQuestionIds: string[] = [];
  initialFormValue: any = null;
  shouldclose = false;
  courseId: string = '';
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  CourseMasterId: number;
  ExamAgencyId: number;
  globalContentParams: any;
  initalSelectionCleared: boolean = false;
  private destroy$ = new Subject<void>();
  private codeLookupCache = new Map<string, Observable<any>>();


  constructor(
    public activeModal: NgbActiveModal,
    private service: ContentManagementService,
    public questionService: QuestionManagementService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private modalService: ModalService,
    private readonly toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private ngModalService: NgbModal,
    private route: ActivatedRoute,
    private contentService: ContentManagementService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.initalizeForm();
  }

  private getCodeCached(tablename: string): Observable<any> {
    const cacheKey = tablename;
    const cachedLookup = this.codeLookupCache.get(cacheKey);
    if (cachedLookup) {
      return cachedLookup;
    }

    const lookup$ = this.service
      .GetCode({ Tablename: tablename })
      .pipe(shareReplay(1));

    this.codeLookupCache.set(cacheKey, lookup$);
    return lookup$;
  }

  hasFormChanged(): boolean {
    if (!this.initialFormValue) return false;
    // Use getRawValue and normalization for best accuracy
    const curr = this.assignForm.getRawValue();
    const initial = this.initialFormValue;
    return JSON.stringify(curr) !== JSON.stringify(initial);
  }

  openSelectPopUp() {
    const modalRef = this.ngModalService.open(QuestionMultipleAssignComponent, {
      size: 'lg',
      centered: true,
      keyboard: true,
      backdrop: 'static', // true (default), false, or 'static' (disables close on click)
      windowClass: 'my-custom-modal-mulitipleassign',
      backdropClass: 'my-custom-backdrop-class',
      scrollable: true,
    });

    modalRef.componentInstance.courseCategoryList = this.courseCategoryList;
    if (this.savedCourseSelection) {
      modalRef.componentInstance.initialSelection = this.savedCourseSelection;
    }
    // Listen for when the modal closes
    modalRef.result
      .then((result) => {
        if (result) {
          this.resetQuestionSelections();
          // Do something with the saved values
          this.initalSelectionCleared = true;

          this.savedCourseSelection = result;
          this.goToNextRoute(result);
          this.courseName = result.courses[0].courseName;
          this.examYearName = result.courses[0].examYearName;
          this.examAgencyName = result.courses[0].examAgencyName;
          this.applyPopupToSelectedQuestions(result);
          setTimeout(() => {
            this.disableAlreadyAssignedCheckboxes();
          }, 0);
          this.cdr.detectChanges();
        }
      })
      .catch(() => {
        // Modal dismissed (cancel or backdrop click)
      });
  }


    goToNextRoute(result: ISelectedCourses | null,) {
      if(!result){
        this.toaster.error('Please fill all the fields for selection', 'Error');
        return;
      }
      const examAgency =result.courses[0].examAgencyName;
      const courseName = result.courses[0].courseName;
      const examYear = result.courses[0].examYear;
      const examYearName = result.courses[0].examYearName;
      const navigationExtras: NavigationExtras = {
        queryParams: {
          c_id: result.courses[0].examYear,
          eA_Name: examAgency,
          c_Name:  courseName,
          eY_Name: examYearName,
          cM_id: result.courses[0].courseId,
          eA_Id: result.courses[0].examAgency,
          cC_Code: result.selectedCategory,
          cC_Name: result.selectedCategoryName,
        },
        skipLocationChange: false,
        state: { value: result.courses[0].examYear },
      };
      this.contentService.setQueryParams({
        c_id: result.courses[0].examYear,
        eA_Name: examAgency,
        c_Name: courseName,
        eY_Name: examYearName,
        cM_id: result.courses[0].courseId,
        eA_Id: result.courses[0].examAgency,
        cC_Code: result.selectedCategory,
        cC_Name: result.selectedCategory,
      });
      if (this.currentRoute) {
        if (this.param) {
          this.router.navigate([`${this.currentRoute}/${this.param}`], navigationExtras);
        } else {
          this.router.navigate([this.currentRoute], navigationExtras);
        }
      }
    }
  clearSelectedCourse() {
    this.savedCourseSelection = null;
    this.courseName = null;
    this.examYearName = null;
    this.examAgencyName = null;
    this.initalSelectionCleared = true;
    this.resetQuestionSelections();
    // Enable ALL course category checkboxes for all questions
    this.questionArray.controls.forEach((questionGroup) => {
      const courseCategoryArray = questionGroup.get(
        'courseCategoryType'
      ) as FormArray;
      courseCategoryArray.controls.forEach((ctrl) => {
        ctrl.get('SelectedInd')?.enable({ emitEvent: false });
      });
    });
    // this.clearSelectedCourse1();

    this.cdr.detectChanges();
  }

    clearSelectedCourseWithRoute() {
    // Clear displayed fields
    this.courseId = '';
    this.ExamAgencyName = '';
    this.CourseName = '';
    this.ExamYear = '';
    this.globalContentParams = {};

    // Reset query params in the service
    this.service.setQueryParams({
      c_id: null,
      eA_Name: null,
      c_Name: null,
      eY_Name: null,
      eA_Id: null,
    });

    // Optional: If you want to clear query params from the URL, do this:
    this.router.navigate([], {
      queryParams: {
        c_id: null,
        eA_Name: null,
        c_Name: null,
        eY_Name: null,
        eA_Id: null,
      },
      queryParamsHandling: 'merge',
    });
    this.clearedRoute.emit(true)
    this.clearSelectedCourse()
  }


  applyPopupToSelectedQuestions(popupResult: any) {
    this.questionArray.controls.forEach((questionGroup, i) => {
      if (questionGroup.get('selected')?.value) {
        this.patchSelectedCoursesToQuestion(i, popupResult);
      }
    });
  }

  // Add this function to your component
  onQuestionSelectedChange(questionIndex: number, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked && this.savedCourseSelection) {
      // If checked, patch the selection from the popup
      this.patchSelectedCoursesToQuestion(
        questionIndex,
        this.savedCourseSelection
      );
    } else {
      // If unchecked, clear the selection
      this.clearCourseSelectionFromQuestion(questionIndex);
    }
  }

  // Add this helper method to remove category & course data for this question
  clearCourseSelectionFromQuestion(questionIndex: number) {
    const questionGroup = this.questionArray.at(questionIndex) as FormGroup;

    // 1. Unselect only the category that was selected from popup (optional, if needed)
    const categoryArray = questionGroup.get('courseCategoryType') as FormArray;
    categoryArray.controls.forEach((ctrl) => {
      // Remove or uncheck only if it has isFromPopup true
      if (ctrl.get('isFromPopup')?.value) {
        ctrl.patchValue({ SelectedInd: false });
      }
    });

    // 2. Remove only popup-added courses
    const coursesArray = questionGroup.get('applicableCourses') as FormArray;
    for (let i = coursesArray.length - 1; i >= 0; i--) {
      if (coursesArray.at(i).get('isFromPopup')?.value) {
        coursesArray.removeAt(i);
      }
    }
  }

  patchSelectedCoursesToQuestion(questionIndex: number, popupResult: any) {
    const questionGroup = this.questionArray.at(questionIndex) as FormGroup;

    // Select the category in the form if not already selected
    const categoryArray = questionGroup.get('courseCategoryType') as FormArray;
    categoryArray.controls.forEach((ctrl) => {
      if (
        ctrl.value.CourseCategoryTypeCode === popupResult.selectedCategory &&
        !ctrl.value.SelectedInd
      ) {
        ctrl.patchValue({ SelectedInd: true });
      }
    });

    const coursesArray = questionGroup.get('applicableCourses') as FormArray;

    popupResult.courses.forEach((course: any) => {
      const exists = coursesArray.controls.some(
        (ctrl) =>
          ctrl.value.type === course.type &&
          ctrl.value.courseId == course.courseId &&
          ctrl.value.examAgency == course.examAgency &&
          ctrl.value.examYear == course.examYear &&
          ctrl.value.deleteInd !== 'Y'
      );

      if (!exists) {
        forkJoin([
          this.getCodeCached(`EXAM_AGENCY@${course.type}`),
          this.getCodeCached(
            `EXAM_COURSE@${course.examAgency}@Course_Category_Type@${course.type}`
          ),
          this.getCodeCached(`COURSE_YEAR@${course.courseId}@${course.type}`),
        ]).subscribe(([examAgencyList, courseList, courseYear]) => {
          const fg = this.fb.group({
            courseId: [course.courseId, Validators.required],
            examAgency: [course.examAgency, Validators.required],
            examYear: [course.examYear, Validators.required],
            QuestionDifficultyLevelTypeCode: ['', Validators.required],
            pastYear: [{ value: false, disabled: true }],
            deleteInd: [course.deleteInd || 'N'],
            courseList: [courseList || []],
            courseYear: [courseYear || []],
            type: [course.type],
            examAgencyList: [examAgencyList || []],
            isFromPopup: [true],
          });

          // Enable checkbox if examYear exists
          if (course.examYear) {
            this.enablePastYearFormControl(fg as FormGroup);
          }

          coursesArray.push(fg);
          this.cdr.detectChanges(); // Trigger view update
        });
      }
    });
  }

  isQuestionAlreadyAssignedFromPopup(questionIndex: number): boolean {
    console.log(
      'Disabled check for question:',
      questionIndex,
      'selection:',
      this.savedCourseSelection
    );
    if (!this.savedCourseSelection) return false;

    const questionGroup = this.questionArray.at(questionIndex) as FormGroup;
    const categoryArray = questionGroup.get('courseCategoryType') as FormArray;
    const coursesArray = questionGroup.get('applicableCourses') as FormArray;
    // 1. Check if the category is already selected
    const categorySelected = categoryArray.controls.some(
      (ctrl) =>
        ctrl.value.CourseCategoryTypeCode ===
          this.savedCourseSelection?.selectedCategory && ctrl.value.SelectedInd
    );

    if (!categorySelected) return false;

    // 2. Check if all courses from popup are present (and not deleted)
    const allCoursesPresent = this.savedCourseSelection.courses.every(
      (popupCourse: any) => {
        return coursesArray.controls.some(
          (ctrl) =>
            ctrl.value.type === popupCourse.type &&
            ctrl.value.courseId == popupCourse.courseId &&
            ctrl.value.examAgency == popupCourse.examAgency &&
            ctrl.value.examYear == popupCourse.examYear &&
            ctrl.value.deleteInd !== 'Y'
        );
      }
    );

    return allCoursesPresent;
  }

  disableAlreadyAssignedCheckboxes() {
    const selectedCategoryCode = this.savedCourseSelection?.selectedCategory;

    this.questionArray.controls.forEach((questionGroup, i) => {
      const selectedCtrl = questionGroup.get('selected');
      const courseCategoryArray = questionGroup.get(
        'courseCategoryType'
      ) as FormArray;

      if (!selectedCtrl || !courseCategoryArray) return;

      const hasMatchingCategory = courseCategoryArray.controls.some(
        (ctrl) =>
          ctrl.get('CourseCategoryTypeCode')?.value === selectedCategoryCode
      );

      const matchesPopupCourses = this.savedCourseSelection?.courses.every(
        (popupCourse) => {
          const coursesArray = questionGroup.get(
            'applicableCourses'
          ) as FormArray;
          return coursesArray.controls.some(
            (ctrl) =>
              ctrl.get('courseId')?.value == popupCourse.courseId &&
              ctrl.get('examAgency')?.value == popupCourse.examAgency &&
              ctrl.get('examYear')?.value == popupCourse.examYear &&
              ctrl.get('type')?.value == popupCourse.type &&
              ctrl.get('deleteInd')?.value !== 'Y'
          );
        }
      );

      const shouldDisableAndCheck = hasMatchingCategory && matchesPopupCourses;

      if (shouldDisableAndCheck) {
        selectedCtrl.setValue(true, { emitEvent: false });
        selectedCtrl.disable({ emitEvent: false });
      } else {
        selectedCtrl.enable({ emitEvent: false });
        selectedCtrl.setValue(false, { emitEvent: false });
      }

      // Handle the course category checkbox too
      courseCategoryArray.controls.forEach((ctrl) => {
        const ctrlCode = ctrl.get('CourseCategoryTypeCode')?.value;
        const selectedInd = ctrl.get('SelectedInd');

        // If the category matches the popup and is checked, always disable it
        if (ctrlCode === selectedCategoryCode && selectedInd?.value === true) {
          selectedInd?.disable({ emitEvent: false });
        } else {
          selectedInd?.enable({ emitEvent: false });
        }
      });
    });

    this.cdr.detectChanges();
  }

  initalizeForm() {
    this.assignForm = this.fb.group({
      questionsArray: this.fb.array([]),
    });
    const data = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      Screenname: this.ScreenName,
    };
    const applicableCoursesCategoryPayload = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      SelectedInd: 'Y',
      ScreenName: 'ASSIGN_QUESTION_TO_COURSE',
    };
    const applicableCourseCategories = {
      ScreenName: 'ASSIGN_QUESTION_TO_COURSE',
      QuestionID: this.QuestionId,
      CourseID: null,
      SubjectId: this.SubjectId,
      SelectedInd: 'Y',
    };

    forkJoin([
      this.service.getDropdownListByCode('COURSE_CATEGORY_TYPE').pipe(
              catchError((err) => {
                return of([]);
              })
            ),
      this.questionService.getQuestionAndAnswers$(data),
      this.questionService.getPath$(pathPayload),
      this.questionService.getQuestionApplicableCourseCategory$(
        applicableCoursesCategoryPayload
      ) .pipe(
              catchError((err) => {
                return of([]);
              })
            ),
      this.questionService.getQuestionApplicableCourse$(
        applicableCourseCategories
      ) .pipe(
              catchError((err) => {
                return of([]);
              })
            ),
      this.questionService.getQuestionRealtionType$({
        Tablename: 'QUESTION_DIFFICULTY_LEVEL_TYPE',
      }),
    ]).subscribe(
      ([
        courseCategoryType,
        questions,
        path,
        applicableCoursesCategory,
        applicableCourses,
        questionDifficulty,
      ]) => {
        this.applicableCoursesCategory = applicableCoursesCategory;
        this.applicableCourse = applicableCourses;
        this.Questions = questions;
        this.QuestionDifficulty = questionDifficulty;
        this.path = path;
        this.courseCategoryList = courseCategoryType as IGetCodes[];
        const questionsArray = this.assignForm.get(
          'questionsArray'
        ) as FormArray;
        const patchObservables: any = [];
        this.Questions.reverse().forEach((question, index) => {
          questionsArray.push(this.getQuestionGroup(question));
          this.makeCourseCategoryTypeCheckboxes(index, question);
          // Collect the observable (returns Observable or null)
          const obs = this.patchApplicableCoursesReturnObservable(
            question,
            index
          );
          if (obs) patchObservables.push(obs);
        });
        if (patchObservables.length) {
          forkJoin(patchObservables).subscribe(() => {
            if (!this.initalSelectionCleared) {
              combineLatest([
                this.route.queryParams.pipe(takeUntil(this.destroy$)),
                this.service.queryParams$.pipe(takeUntil(this.destroy$)),
              ]).subscribe(([queryParams, serviceParams]) => {
                // Extract values (with fallbacks)
                const courseId = queryParams['cM_id'] || serviceParams['cM_id'];
                const courseName =
                  queryParams['c_Name'] || serviceParams['c_Name'];
                const examAgencyId =
                  queryParams['eA_Id'] || serviceParams['eA_Id'];
                const examAgencyName =
                  queryParams['eA_Name'] || serviceParams['eA_Name'];
                const examYear = queryParams['c_id'] || serviceParams['c_id'];
                const examYearName =
                  queryParams['eY_Name'] || serviceParams['eY_Name'];
                const categoryCode =
                  queryParams['cC_Code'] || serviceParams['cC_Code'];
                const categoryName =
                  queryParams['cC_Name'] || serviceParams['cC_Name'];
                // Check if all required parameters exist
                if (
                  courseId &&
                  courseName &&
                  examAgencyId &&
                  examAgencyName &&
                  examYear &&
                  examYearName
                ) {
                  const categoryData = {
                    selectedCategory: categoryCode,
                    selectedCategoryName: categoryName,
                    courses: [
                      {
                        courseId: courseId,
                        courseName: courseName,
                        examAgency: examAgencyId,
                        examAgencyName: examAgencyName,
                        examYear: examYear,
                        examYearName: examYearName,
                        deleteInd: 'N',
                        type: categoryCode,
                      },
                    ],
                  };
                  this.resetQuestionSelections();
                  // Do something with the saved values
                  this.savedCourseSelection = categoryData;
                  this.courseName = categoryData.courses[0].courseName;
                  this.examYearName = categoryData.courses[0].examYearName;
                  this.examAgencyName = categoryData.courses[0].examAgencyName;
                  this.applyPopupToSelectedQuestions(categoryData);
                  setTimeout(() => {
                    this.disableAlreadyAssignedCheckboxes();
                    this.initialFormValue = JSON.parse(
                      JSON.stringify(this.assignForm.getRawValue())
                    );
                  }, 0);
                  this.cdr.detectChanges();
                }
              });
            }
            // All patching finished
            this.initialFormValue = JSON.parse(
              JSON.stringify(this.assignForm.getRawValue())
            );
          });
        } else {
          // No async patching needed
          this.initialFormValue = JSON.parse(
            JSON.stringify(this.assignForm.getRawValue())
          );
        }
      }
    );
  }
  patchApplicableCoursesReturnObservable(
    question: IQuestionsWithAnswersModifiedResponse,
    questionIndex: number
  ): Observable<any> | null {
    if (!this.applicableCourse?.length) return of(null);
    if (
      !this.applicableCourse.some((e) => e.Question_ID === question.Question_ID)
    )
      return of(null);

    const aCArray = this.applicableCourse.filter(
      (e) => e.Question_ID === question.Question_ID
    );
    const QuestionFormGroup = this.questionArray.at(questionIndex);
    if (!QuestionFormGroup) return of(null);
    const applicableCourseFormArray = QuestionFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    // Build an array of patch observables for this question
    const obsArray = aCArray.map((ac) =>
      forkJoin([
        this.getCodeCached(`EXAM_AGENCY@${ac?.Course_Category_Type_Code}`),
        this.getCodeCached(
          `EXAM_COURSE@${ac.Exam_agency_ID}@Course_Category_Type@${ac.Course_Category_Type_Code}`
        ),
        this.getCodeCached(
          `COURSE_YEAR@${ac.Course_Master_Id}@${ac.Course_Category_Type_Code}`
        ),
      ]).pipe(
        tap(([examAgencyList, courseList, courseYear]) => {
          applicableCourseFormArray.push(
            this.fb.group({
              courseId: [ac?.Course_Master_Id, Validators.required],
              examAgency: [ac?.Exam_agency_ID, Validators.required],
              examYear: [ac?.Course_ID, Validators.required],
              QuestionDifficultyLevelTypeCode: [
                ac?.Question_Difficulty_Level_Type_Code,
                Validators.required,
              ],
              pastYear: [ac?.Previously_Asked_IND === 'Y'],
              deleteInd: [ac.Deleted_Ind],
              courseList: [courseList],
              courseYear: [courseYear],
              type: [ac?.Course_Category_Type_Code],
              examAgencyList: [examAgencyList],
            })
          );
        })
      )
    );
    // Return forkJoin of all patches for this question
    return forkJoin(obsArray);
  }

  isFormDirty(): boolean {
    return this.assignForm.dirty;
  }

  updateSelectedStatusBasedOnChanges(questionIndex: number) {
    const questionGroup = this.questionArray.at(questionIndex) as FormGroup;
    const questionId = questionGroup.get('questionId')?.value;

    const shouldRemainSelected =
      this.isQuestionAlreadyAssignedFromPopup(questionIndex);

    if (!shouldRemainSelected) {
      // Re-enable and uncheck the checkbox
      questionGroup.get('selected')?.enable({ emitEvent: false });
      questionGroup.get('selected')?.setValue(false, { emitEvent: false });

      // Remove from saved list
      const idx = this.successfullySavedQuestionIds.indexOf(questionId);
      if (idx !== -1) {
        this.successfullySavedQuestionIds.splice(idx, 1);
      }
    }
  }

  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  // CHECK IF QUESTION COURSE CATEGORY SELECTED
  checkifQCCSelected(
    question: IQuestionsWithAnswersModifiedResponse,
    category: string
  ): boolean {
    return this.applicableCoursesCategory.some(
      (e) =>
        e.Course_Category_Type_Code === category &&
        e.Question_Id === question.Question_ID
    );
  }

  triggerParentFunction(question: IQuestionsWithAnswersModifiedResponse): void {
    // Emit data to the parent component
    const data = {
      Question_Id: question.Question_ID,
      Questions: this.Questions,
      Subject_Id: this.SubjectId,
    };
    this.openQuestionEdit.emit(data);
  }

  makeCourseCategoryTypeCheckboxes(
    index = 0,
    question: IQuestionsWithAnswersModifiedResponse
  ) {
    const questionsArray = this.assignForm.get('questionsArray') as FormArray;
    const courseCategoryArray = questionsArray
      .at(index)
      .get('courseCategoryType') as FormArray;

    this.courseCategoryList.forEach((category) => {
      const isSelected = this.checkifQCCSelected(question, category.Code);

      // --- Add this logic ---
      let isDisabled = false;
      // If there is a saved popup selection and this is the selected category, disable it
      if (
        this.savedCourseSelection &&
        this.savedCourseSelection.selectedCategory === category.Code &&
        isSelected // (you can further customize this condition as needed)
      ) {
        isDisabled = true;
      }

      // Create FormGroup, and then disable if needed
      const group = this.fb.group({
        CourseCategoryTypeCode: category.Code,
        CourseCategoryTypeName: category.Description,
        SelectedInd: isSelected,
      });

      if (isDisabled) {
        group.get('SelectedInd')?.disable({ emitEvent: false });
      }

      courseCategoryArray.push(group);
    });
  }

  getQuestionGroup(question: IQuestionsWithAnswersModifiedResponse): FormGroup {
    const isSelected = this.successfullySavedQuestionIds?.includes(
      question?.Question_ID
    );

    const control = this.fb.group({
      selected: [{ value: isSelected || false, disabled: isSelected }],
      courseCategoryType: this.fb.array([]),
      applicableCourses: this.fb.array([]),
      questionId: this.fb.control(question?.Question_ID),
    });

    return control;
  }

  get questionArray(): FormArray {
    return this.assignForm.get('questionsArray') as FormArray;
  }

  getFormControlsForQuestion(index: number, controlName: string) {
    return (
      (this.questionArray.at(index).get(controlName) as FormArray) ||
      new FormArray([])
    );
  }

  logAndReturn<T>(value: T, label: string): T {
    return value;
  }
  getApplicableCourseTypeElementForAQuestion(
    questionIndex: number,
    courseCategoryIndex: number
  ) {
    const courseCategoryArray = this.questionArray
      .at(questionIndex)
      .get('courseCategoryType') as FormArray;
    const courseCategory = courseCategoryArray.at(courseCategoryIndex);
    return courseCategory;
  }

  getQuestions() {
    const data = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
    };
    this.questionService.getQuestionAndAnswers$(data).subscribe(
      (res) => {},
      (error) => {}
    );
  }

  patchApplicableCourses(
    question: IQuestionsWithAnswersModifiedResponse,
    questionIndex: number
  ) {
    if (!this.applicableCourse?.length) return; // Ensure applicableCourse exists

    if (
      this.applicableCourse.some((e) => e.Question_ID === question.Question_ID)
    ) {
      const aCArray = this.applicableCourse.filter(
        (e) => e.Question_ID === question.Question_ID
      );

      const QuestionFormGroup = this.questionArray.at(questionIndex);
      if (!QuestionFormGroup) return; // Ensure the QuestionFormGroup exists

      const applicableCourseFormArray = QuestionFormGroup.get(
        'applicableCourses'
      ) as FormArray;

      aCArray.forEach((ac) => {
        forkJoin([
          this.service.GetCode({
            Tablename: `EXAM_AGENCY@${ac?.Course_Category_Type_Code}`,
          }),
          this.service.GetCode({
            Tablename: `EXAM_COURSE@${ac.Exam_agency_ID}@Course_Category_Type@${ac.Course_Category_Type_Code}`,
          }),
          this.service.GetCode({
            Tablename: `COURSE_YEAR@${ac.Course_Master_Id}@${ac.Course_Category_Type_Code}`,
          }),
        ]).subscribe(([examAgencyList, courseList, courseYear]) => {
          applicableCourseFormArray.push(
            this.fb.group({
              courseId: [ac?.Course_Master_Id, Validators.required],
              examAgency: [ac?.Exam_agency_ID, Validators.required],
              examYear: [ac?.Course_ID, Validators.required],
              QuestionDifficultyLevelTypeCode: [
                ac?.Question_Difficulty_Level_Type_Code,
                Validators.required,
              ],
              pastYear: [ac?.Previously_Asked_IND === 'Y'],
              deleteInd: [ac.Deleted_Ind],
              courseList: [courseList],
              courseYear: [courseYear],
              type: [ac?.Course_Category_Type_Code],
              examAgencyList: [examAgencyList],
            })
          );
        });
      });
    }
  }

  addApplicableCourse(questionIndex: number, item: IGetCodes): void {
    const QuestionFormGroup = this.questionArray.at(questionIndex);
    const applicableCourseFormArray = QuestionFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    if (this.validateExamData(applicableCourseFormArray.value, item.Code)) {
      return;
    } else if (
      this.hasDuplicateExamYear(
        applicableCourseFormArray.value.filter(
          (e: any) => e.type === item.Code && e.deleteInd !== 'Y'
        )
      )
    ) {
      this.toaster.error('Remove the duplicates', 'Error', { timeOut: 5000 });
      return;
    } else {
      // #region Adding AppliacbleCourses
      this.addApplicableCourses(item, applicableCourseFormArray);
    }
  }

  validateExamData(examData: any[], newType: string): boolean {
    let missingFieldsByType: Record<string, string[]> = {}; // Store missing fields per type
    let typeValidation: Record<string, boolean> = {}; // Track valid types
    // Filter out objects where deleteInd is 'Y'
    let validData = examData.filter((item) => item.deleteInd !== 'Y');
    validData.forEach((item: any, index: number) => {
      let errors: string[] = [];

      if (!item.examAgency) {
        errors.push('examAgency');
      }
      if (!item.courseId) {
        errors.push('courseId');
      }
      if (!item.examYear) {
        errors.push('examYear');
      }

      if (errors.length > 0) {
        if (!missingFieldsByType[item.type]) {
          missingFieldsByType[item.type] = [];
        }
        missingFieldsByType[item.type].push(
          `Row ${index + 1} (Type: ${item.type}) is missing fields`
        );
        typeValidation[item.type] = false; // Mark type as invalid
      } else {
        typeValidation[item.type] = true; // At least one valid object exists for this type
      }
    });

    // Check if the specific type of the new object is valid
    if (missingFieldsByType[newType] && !typeValidation[newType]) {
      this.toaster.error(
        `You cannot add a new object for type "${newType}" because existing ones have missing fields`,
        'Error',
        { timeOut: 5000 }
      );
      return true; // Prevent adding new object of this type
    }
    return false; // Allow adding object
  }

  hasDuplicateExamYear(arr: any[]): boolean {
    const examYearSet = new Set();
    for (const item of arr) {
      if (examYearSet.has(+item.examYear)) {
        return true; // Duplicate found
      }
      examYearSet.add(+item.examYear);
    }
    return false; // No duplicates
  }

  checkifCategoryTypeNotEmpty(code: string, questionIndex: number) {
    const questionFormGroup = this.questionArray.at(questionIndex);
    const courseForArray = questionFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    return !courseForArray?.value.some(
      (e: any) => e.type === code && e.deleteInd === 'N'
    );
  }

  checkifCategoryTypeNotEmptyonSave(code: string, questionIndex: number) {
    const questionFormGroup = this.questionArray.at(questionIndex);
    const courseForArray = questionFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    return !courseForArray?.value.some(
      (e: any) => e.type === code && e.deleteInd === 'N' && e.examYear
    );
  }

  checkIfCourseYearAlreadySelected(
    applicableCourse: any,
    applicableCoursesArray: any,
    applicableCourseIndex: number,
    questionindex: number
  ) {
    this.enablePastYearFormControl(applicableCourse);
    const notDeletedApplicableCoursesArray =
      applicableCoursesArray.value.filter((e: any) => e.deleteInd !== 'Y');
    const { duplicateIndices, hasDuplicates } =
      this.hasDuplicateCourseIdAndExamYear(
        notDeletedApplicableCoursesArray ?? []
      );

    if (hasDuplicates) {
      // Find the specific control in the array that has the duplicate
      const duplicateIndex = applicableCoursesArray.controls
        .map((control: FormGroup) => control.value.examYear)
        .lastIndexOf(applicableCourse.value.examYear);

      if (duplicateIndex !== -1) {
        const fControl = applicableCoursesArray.controls[
          applicableCourseIndex
        ] as FormControl;
        const examYearControl = fControl.get('examYear');
        // Revert to previous value
        examYearControl?.setValue(null); // or set it to a default value
        const courseList = fControl.get('courseList')?.value;
        const courseId = fControl.get('courseId')?.value;
        const courseName =
          courseList.find((e: any) => +e.Code === +courseId)?.Description ?? '';
        this.toaster.error(
          `Course year is already selected for "${courseName}"`,
          'Error',
          { timeOut: 5000 }
        );
      }

      return;
    }
    this.disableAlreadyAssignedCheckboxes();
  }

  enablePastYearFormControl(courseFormGroup: FormGroup) {
    const formgroup = courseFormGroup.getRawValue();
    courseFormGroup.get('pastYear')?.setValue(false);
    courseFormGroup.updateValueAndValidity();
    if (formgroup.examYear) {
      courseFormGroup.get('pastYear')?.enable();
    } else {
      courseFormGroup.get('pastYear')?.disable();
    }
  }

  hasDuplicateCourseIdAndExamYear(array: any[]): {
    hasDuplicates: boolean;
    duplicateIndices: number[];
  } {
    const seen = new Map();
    const duplicateIndices: number[] = [];
    array.forEach((item, index) => {
      const key = `${item.courseId}-${item.examYear}`;

      if (seen.has(key)) {
        if (!duplicateIndices.includes(seen.get(key))) {
          duplicateIndices.push(seen.get(key));
        }
        duplicateIndices.push(index);
      } else {
        seen.set(key, index);
      }
    });

    return { hasDuplicates: duplicateIndices.length > 0, duplicateIndices };
  }

  async deleteApplicableCourseElement(
    questionIndex: number,
    applicableCourseFormArrayIndex: number
  ) {
    try {
      const result = await this.modalService.open(
        'Confirmation',
        'Are you sure you want to delete this Applicable Course?'
      );
      if (result) {
        const applicableCoursesArray = this.questionArray
          .at(questionIndex)
          .get('applicableCourses') as FormArray;
        const formGroup = applicableCoursesArray.at(
          applicableCourseFormArrayIndex
        ) as FormGroup;
        if (formGroup.get('examYear')?.hasError('sameCourse')) {
          applicableCoursesArray.removeAt(applicableCourseFormArrayIndex);
          applicableCoursesArray.updateValueAndValidity();
          this.cdr.detectChanges();
        } else {
          const fGroup = applicableCoursesArray.at(
            applicableCourseFormArrayIndex
          ) as FormGroup;

          fGroup.patchValue({ deleteInd: 'Y' });

          // Remove required validators
          [
            'courseId',
            'examAgency',
            'examYear',
            'QuestionDifficultyLevelTypeCode',
          ].forEach((field) => {
            fGroup.get(field)?.removeValidators(Validators.required);
            fGroup.get(field)?.updateValueAndValidity();
          });

          // If the deleted course matches the savedCourseSelection, enable and uncheck 'selected'
          if (this.savedCourseSelection) {
            const deletedCourse = fGroup.value;
            const match = this.savedCourseSelection.courses.some(
              (sc: any) =>
                sc.courseId == deletedCourse.courseId &&
                sc.examAgency == deletedCourse.examAgency &&
                sc.examYear == deletedCourse.examYear &&
                sc.type == deletedCourse.type
            );
            if (match) {
              const questionGroup = this.questionArray.at(
                questionIndex
              ) as FormGroup;
              const selectedCtrl = questionGroup.get('selected');
              if (selectedCtrl) {
                selectedCtrl.enable({ emitEvent: false });
                selectedCtrl.setValue(false, { emitEvent: false });
              }
            }
          }
          // -------------------------------------------------------

          this.handleCategoryAfterCourseDelete(questionIndex);
          this.cdr.detectChanges();
        }
      }
    } catch (error) {}
  }

  /**
   * After deletion, checks if a course category for a question has only one applicable course left.
   * If so, unchecks and enables the category checkbox.
   */
  handleCategoryAfterCourseDelete(questionIndex: number) {
    const questionGroup = this.questionArray.at(questionIndex) as FormGroup;
    const courseCategoryArray = questionGroup.get(
      'courseCategoryType'
    ) as FormArray;
    const applicableCoursesArray = questionGroup.get(
      'applicableCourses'
    ) as FormArray;

    courseCategoryArray.controls.forEach((categoryCtrl, ccIndex) => {
      const categoryCode = categoryCtrl.get('CourseCategoryTypeCode')?.value;
      const selectedIndCtrl = categoryCtrl.get('SelectedInd');

      // Count how many courses of this category remain and are NOT deleted
      const remainingCourses = applicableCoursesArray.controls.filter(
        (ctrl) =>
          ctrl.get('type')?.value === categoryCode &&
          ctrl.get('deleteInd')?.value !== 'Y'
      );

      // Only uncheck and enable if there are ZERO courses left
      if (remainingCourses.length === 0) {
        selectedIndCtrl?.setValue(false, { emitEvent: false });
        selectedIndCtrl?.enable({ emitEvent: false });
      }
    });
  }

  onCourseCategoryTypeChange(
    event: any,
    cCType: AbstractControl,
    questionIndex: number
  ) {
    if (!event.target.checked) {
      const applicableCoursesArray = this.questionArray
        .at(questionIndex)
        .get('applicableCourses') as FormArray;
      applicableCoursesArray.value.forEach((e: any, index: number) => {
        if (e.type === cCType.value.CourseCategoryTypeCode) {
          const formGroup = applicableCoursesArray.at(index);
          formGroup.get('deleteInd')?.setValue('Y');
          [
            'courseId',
            'examAgency',
            'examYear',
            'QuestionDifficultyLevelTypeCode',
          ].forEach((field) => {
            formGroup.get(field)?.removeValidators(Validators.required);
            formGroup.get(field)?.updateValueAndValidity();
          });
        }
      });
    } else {
      const courseCategoryType = cCType.value;
      const applicableCoursesArray = this.questionArray
        .at(questionIndex)
        .get('applicableCourses') as FormArray;
      this.addApplicableCourses(
        {
          Code: courseCategoryType.CourseCategoryTypeCode,
          Description: courseCategoryType.CourseCategoryTypeCode,
          Status: 'Active',
          Display_Order: 0,
        },
        applicableCoursesArray
      );
    }
    const applicableCoursesArray = this.questionArray
      .at(questionIndex)
      .get('applicableCourses') as FormArray;
  }
  // #region Add Courses
  addApplicableCourses(
    courseCategoryType: IGetCodes,
    applicableCoursesFormArray: FormArray
  ) {
    this.service
      .GetCode({
        Tablename: `EXAM_AGENCY@${courseCategoryType.Code}`,
      })
      .subscribe((elem: any) => {
        applicableCoursesFormArray.push(
          this.fb.group({
            courseId: ['', Validators.required],
            examAgency: ['', Validators.required],
            examYear: ['', Validators.required],
            QuestionDifficultyLevelTypeCode: ['', Validators.required],
            pastYear: [{ value: false, disabled: true }],
            deleteInd: ['N'],
            courseList: [],
            courseYear: [],
            type: [courseCategoryType.Code],
            examAgencyList: [elem],
          })
        );
      });
  }

  fetchCourseBasedOnExam(appInstance: any, item: any) {
    this.service
      .GetCode({
        Tablename: `EXAM_COURSE_SHORT_NAME@${appInstance.value.examAgency}@Course_Category_Type@${item.Code}`,
      })
      .subscribe((elem) => {
        appInstance.get('courseList').setValue(elem || []);
        appInstance.get('courseYear').setValue([]);
        appInstance.get('pastYear').setValue('');
        appInstance.get('courseId').setValue('');
        appInstance.get('examYear').reset();

        appInstance.get('pastYear').disable();
        appInstance.get('pastYear').updateValueAndValidity();
        appInstance.get('courseId').updateValueAndValidity();
      });
  }

  fetchCourseYear(appExam: any, item: any) {
    this.service
      .GetCode({
        Tablename: `COURSE_YEAR@${appExam.value.courseId}@${item.Code}`,
      })
      .subscribe((elem) => {
        appExam.get('courseYear').setValue(elem || []);
        appExam.get('pastYear').setValue('');
        appExam.get('examYear').reset();
        appExam.get('pastYear').disable();

        appExam.get('pastYear').updateValueAndValidity();
      });
  }

  resetQuestionSelections() {
    this.questionArray.controls.forEach((questionGroup) => {
      // Enable and uncheck the 'selected' checkbox
      questionGroup.get('selected')?.enable({ emitEvent: false });
      questionGroup.get('selected')?.setValue(false, { emitEvent: false });
    });
    this.cdr.detectChanges();
  }

  onCross() {
    if (this.hasFormChanged()) {
      this.modalService
        .open(
          'Confirmation',
          'You have unsaved changes. Do you want to save before leaving?'
        )
        .then((result: boolean) => {
          if (result) {
            this.shouldclose = true;
            this.onSave();
          } else {
            this.activeModal.close(false);
          }
        });
    } else {
      this.activeModal.close(false);
    }
  }

  // #region On Save
  onSave() {
    if (this.assignForm.valid) {
      const selectedQuestionIds = this.questionArray.controls
        .filter((q) => q.get('selected')?.value)
        .map((q) => q.get('questionId')?.value);

      const data = {
        ErrorMessage: '',
        QuestionApplicableCourseCategoryList:
          [] as QuestionApplicableCourseCategoryList[],
        QuestionApplicableCourseList: [] as QuestionApplicableCourseList[],
      };

      const questionArray = this.assignForm.getRawValue()?.questionsArray || [];

      let errorOccurred = false; // Flag to track if an error has occurred
      this.applicableCourse.forEach((a1Item) => {
        const matchedA2 = questionArray.find(
          (a2Item: any) => a2Item.questionId === a1Item.Question_ID
        );

        if (matchedA2) {
          const exists = matchedA2.applicableCourses.some(
            (course: any) => +course.examYear === +a1Item.Course_ID
          );

          if (!exists) {
            const newCourse = {
              courseId: a1Item.Course_Master_Id,
              examAgency: a1Item.Exam_agency_ID,
              examYear: +a1Item.Course_ID,
              pastYear: a1Item.Previously_Asked_IND === 'Y',
              deleteInd: 'Y',
              courseList: [
                // {
                //     "Code": String(a1Item.Course_Master_Id),
                //     "Description": a1Item.Course_Name,
                //     "Status": "",
                //     "Display_Order": 0
                // }
              ],
              courseYear: [
                // {
                //     "Code": String(a1Item.Exam_Year),
                //     "Description": String(a1Item.Exam_Year),
                //     "Status": "",
                //     "Display_Order": 0
                // }
              ],
              type: a1Item.Course_Category_Type_Code,
              examAgencyList: [
                // {
                //     "Code": String(a1Item.Exam_agency_ID),
                //     "Description": a1Item.Exam_Agency_Name,
                //     "Status": "",
                //     "Display_Order": 0
                // }
              ],
            };

            matchedA2.applicableCourses.push(newCourse);
          }
        }
      });

      questionArray.forEach((element: any, questionIndex: number) => {
        element?.courseCategoryType.forEach((CC: any) => {
          if (
            this.checkifCategoryTypeNotEmptyonSave(
              CC.CourseCategoryTypeCode,
              questionIndex
            )
          ) {
            if (CC.SelectedInd === true) {
              this.toaster.error(
                'There are no Courses selected for ' +
                  CC.CourseCategoryTypeCode +
                  ' in Question ' +
                  element.questionId,
                'Error',
                {
                  timeOut: 5000,
                }
              );
              errorOccurred = true; // Set the error flag
              return;
            }
          }
          if (!errorOccurred) {
            data.QuestionApplicableCourseCategoryList.push({
              QuestionID: element.questionId,
              CourseCategoryTypeCode: CC?.CourseCategoryTypeCode,
              SelectedIND: CC?.SelectedInd ? 'Y' : 'N',
            });
          }
        });
        if (!errorOccurred) {
          element?.applicableCourses
            .filter((e: any) => e.examYear)
            .forEach((AC: any) => {
              data.QuestionApplicableCourseList.push({
                QuestionID: element.questionId,
                CourseID: AC?.examYear,
                PreviouslyAskedIND: AC?.pastYear ? 'Y' : 'N',
                SelectedIND: AC.deleteInd === 'Y' ? 'N' : 'Y',
                QuestionDifficultyLevelTypeCode:
                  AC.QuestionDifficultyLevelTypeCode,
              });
            });
        }
      });

      if (errorOccurred) {
        return; // Stop the API call if an error occurred
      }
      this.questionService.createUpdateApplicableQuestion$(data).subscribe(
        (res) => {
        this.toaster.success('Saved Successfully', 'Success',{timeOut: 500});

          this.successfullySavedQuestionIds = selectedQuestionIds;
          // Promise.resolve().then(() => {
          this.initalizeForm();

          if (this.shouldclose) {
            this.activeModal.close(false);
          }
        },
        (error) => {
          console.log(error);
          if (error.status === 304) {
        this.toaster.success('Saved Successfully', 'Success',{timeOut: 500});
          }
        }
      );
    } else {
      this.toaster.error(`Fill out the empty higlighted fields `, 'Error', {
        timeOut: 5000,
      });
      this.assignForm.markAllAsTouched();
    }
  }
}
